<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
		<!-- {{ val.data.files }} -->
		<div style="width: 90%;" v-if="val.ok">
			<userImg
				id="val_img"
				class="pointer"
				:src="val.data.img.val"
				@click="check_authentication('عکس مدرس', 'img')"
			/>
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						label="نام و نام خانوادگی"
						:val="val.data.fullname.val"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_fullname"
						:empty="true"
						:valid="1"
				
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						label="نام پدر"
						:val="val.data.fatherName.val"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_fatherName"
						:empty="true"
						:valid="1"
				
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						label="جنسیت"
						:val="val.data.sex.val == 1 ? 'مرد' : 'زن'"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_sex"
						:empty="true"
						:valid="1"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						label="شماره موبایل"
						:val="val.data.phone.val"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_phone"
						valid="1"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						:val="val.data.email.val"
						label="ایمیل"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_email"
						:empty="true"
						:valid="val.data.email.act"
						@enter="check_authentication('ایمیل', 'email')"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						label="شماره تماس عمومی"
						:val="val.data.public_phone.val"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_public_phone"
						valid="1"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						:val="val.data.postal_code.val"
						label="کدپستی"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_postal_code"
						:empty="true"
						:valid="val.data.postal_code.act"
						@enter="check_authentication('کدپستی', 'postal_code')"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
					:val="val.data.pid.val"
					label="کد ملی"
					textClass="pointer"
					input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
					id_input="val_pid"
					:empty="true"
					:valid="1"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						val=""
						label="تصویر کارت ملی"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_files"
						:empty="true"
						:valid="val.data.files.act"
						@enter="check_authentication('تصویر کارت ملی', 'files')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						:val="val.data.about_me.val"
						label="درباره من"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_about_me"
						:empty="true"
						:valid="val.data.about_me.act"
						@enter="check_authentication('درباره من', 'about_me')"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
					:val="val.data.address.val"
					label="آدرس آموزشگاه یا محل تدریس"
					textClass="pointer"
					input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
					id_input="val_address"
					:empty="true"
					:valid="val.data.address.act"
					@enter="check_authentication('آدرس آموزشگاه یا محل تدریس', 'address')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
					:val="val.data.home_teacher.val"
					label="آدرس محل سکونت (این آدرس به کاربر نمایش داده نمیشود)"
					textClass="pointer"
					input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
					id_input="val_home_teacher"
					:empty="true"
					:valid="val.data.home_teacher.act"
					@enter="check_authentication('آدرس محل سکونت (این آدرس به کاربر نمایش داده نمیشود)', 'home_teacher')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
					val=""
					label="موقعیت جغرافیایی"
					textClass="pointer"
					input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
					id_input="val_location"
					:empty="true"
					:valid="val.data.location.act"
					@enter="check_authentication('موقعیت جغرافیایی', 'location')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						val=""
						label="تصاویر محل تدریس"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_pic_location"
						:empty="true"
						:valid="val.data.pic_location.act"
						@enter="check_authentication('تصاویر محل تدریس', 'pic_location')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						:val="val.data.degrees.val"
						label="دسته بندی"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_degrees"
						:empty="true"
						:valid="val.data.degrees.act"
						@enter="check_authentication('دسته بندی', 'degrees')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						:val="val.data.cats.val"
						label="موضوع درس"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_cats"
						:empty="true"
						:valid="val.data.cats.act"
						@enter="check_authentication('موضوع درس', 'cats')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						:val="val.data.field.val"
						label="رشته های تحصیلی"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_field"
						:empty="true"
						:valid="val.data.field.act"
						@enter="check_authentication('رشته های تحصیلی', 'field')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						:val="(val.data.online_teaching.val==1) ? '✔️' : '❌'"
						label="آنلاین"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_online_teaching"
						:empty="true"
						:valid="val.data.online_teaching.act"
						@enter="check_authentication('آنلاین', 'online_teaching')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						:val="(val.data.in_person_teaching.val==1) ? '✔️' : '❌'"
						label=" تدریس در محل کاربر"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_in_person_teaching"
						:empty="true"
						:valid="val.data.in_person_teaching.act"
						@enter="check_authentication('تدریس در محل کاربر', 'in_person_teaching')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						:val="(val.data.teaching_home.val==1) ? '✔️' : '❌'"
						label="تدریس در محل استاد"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_teaching_home"
						:empty="true"
						:valid="val.data.teaching_home.act"
						@enter="check_authentication('تدریس در محل استاد', 'teaching_home')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						val=""
						label="بارگزاری تصاویر (اختیاری)"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_image_teacher"
						:empty="true"
						:valid="val.data.image_teacher.act"
						@enter="check_authentication('بارگزاری تصاویر (اختیاری)', 'image_teacher')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						val=""
						label="ویدئو مدرس"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_video"
						:empty="true"
						:valid="val.data.video.act"
						@enter="check_authentication('ویدئو مدرس', 'video')"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						:val="val.data.documents.val"
						label="مدارک تحصیلی"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_documents"
						:empty="true"
						:valid="val.data.documents.act"
						@enter="check_authentication('مدارک تحصیلی', 'documents')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						val=""
						label="تصاویر مدارک تحصیلی"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_pic_documents"
						:empty="true"
						:valid="val.data.pic_documents.act"
						@enter="check_authentication('تصاویر مدارک تحصیلی', 'pic_documents')"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textInput
						:val="val.data.certificate.val"
						label="گواهینامه ها، افتخارات و جوایز"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_certificate"
						:empty="true"
						:valid="val.data.certificate.act"
						@enter="check_authentication('گواهینامه ها، افتخارات و جوایز', 'certificate')"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
					<textInput
						val=""
						label="تصاویر گواهینامه ها، افتخارات و جوایز"
						textClass="pointer"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						id_input="val_pic_certificate"
						:empty="true"
						:valid="val.data.files.act"
						@enter="check_authentication('تصاویر گواهینامه ها، افتخارات و جوایز', 'pic_certificate')"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" >
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<selectInput
						:value="val.data.status.val"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						@inputTxtFunc = "(e)=>{val.data.status.val = e}"
						label="ثبت نتیجه ارزیابی (توسط اپراتور)"
						:class_select="(val.data.status.val=='4') ? 'btn-danger' : ((val.data.status.val=='3') ? 'btn-success text-white' : '')"
						:flds="[
							{'id': '11','name': 'نقص مدارک'},
							{'id': '13','name': 'در انتظار فعال سازی'},
							{'id': '2','name': 'تایید شد/غیرفعال'},
							{'id': '12','name': 'رد شد'}
						]"
					/>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right p-0">
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div
				class="w-100 overflow-hidden"
				v-if="val.data.status.val == 1"
			>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<selectInput
						:value="val.data.level.val"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						@inputTxtFunc = "(e)=>{val.data.level.val = e}"
						label="تعیین سطح مدرس"
						:flds="[
							{'id': '1','name': 'سطح یک'},
							{'id': '2','name': 'سطح دو'},
							{'id': '3','name': 'سطح سه'},
							{'id': '4','name': 'سطح چهار'}
						]"
					/>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right p-0">
					<selectInput
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						:value="val.data.time_class.val"
						@inputTxtFunc = "(e)=>{val.data.time_class.val = e}"
						label="زمان"
						:flds="[
							{'id': '1','name': '30 دقیقه'},
							{'id': '2','name': '45 دقیقه'},
							{'id': '3','name': '60 دقیقه'},
							{'id': '4','name': '90 دقیقه'},
						]"
					/>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right p-0">
					<selectInput
						:value="val.data.price_class.val"
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						@inputTxtFunc = "(e)=>{val.data.price_class.val = e}"
						label="حداکثر قیمت هر جلسه"
						:flds="[
							{'id': '1','name': '300 هزار تومان'},
							{'id': '2','name': '400 هزار تومان'},
							{'id': '3','name': '500 هزار تومان'},
							{'id': '4','name': '600 هزار تومان'},
						]"
					/>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<selectInput
						input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
						:value="val.data.commission.val"
						@inputTxtFunc = "(e)=>{val.data.commission.val = e}"
						label="پورسانت"
						:flds="[
							{'id': '0','name': '0 درصد'},
							{'id': '1','name': '10 درصد'},
							{'id': '2','name': '20 درصد'},
							{'id': '3','name': '30 درصد'},
							{'id': '4','name': '40 درصد'},
							{'id': '5','name': '5 درصد'},
						]"
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="w-100 overflow-hidden" v-if="val.data.status.val == 2 || val.data.status.val == 4 || val.data.status.val == 11 || val.data.status.val == 12">
				<div class="col-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<textareaInput
					input_style="padding-top: 0.5rem !important;background-size: 15px;padding-bottom: 0.5rem !important;"
					:value="val.data.comment.val"
					@inputTxtFunc="(e)=>{val.data.comment.val = e}"
					label="توضیحات"
					placeholder="توضیحات اپراتور در اینجا نوشته شود..."
					/>
				</div>
			</div>
			<!-- ------------------------------------------------------------------------- -->
			<div class="pt-3 w-100 overflow-hidden">
				<div class="col-12 float-right" :class="(windowWidth>770) ? 'p-0' : 'p-0'">
					<btn
						text=" ثبت "
						textClass="float-left"
						@clickMe="sav_final()"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
	<script>
		import btn from  "../../UI/button/btn.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import multiSelectInput from  "../../UI/input/multiSelectInput.vue";
		import selectInput from  "../../UI/input/selectInput.vue";
		import textareaInput from  "../../UI/input/textareaInput.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import uploadFile from  "../../UI/uploadFile/file.vue";
		import { validateEmail, validatePhone, indexFinder } from  "../../assets/library/filter.js";
		import { success, error, loading, success_sm } from  "../../assets/library/messege.js";

		export default {
			name: 'self_part1',
			data(){
				return {
					validateEmail: validateEmail,
					validatePhone: validatePhone,
					indexFinder: indexFinder,
					success: success,
					success_sm: success_sm,
					error: error,
					loading: loading,
					imgurl: window.imgurl,
					baseurl: window.baseurl,
					sendSms: window.sendSms,
					val:{ok: false,},
				}
			},
			components: {
				btn,
				uploadFile,
				validateEmail,
				validateEmail,
				textInput,
				selectInput,
				pageNavigation,
				userImg,
				textareaInput,
				multiSelectInput,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(THIS = this){
				THIS.loading(THIS);
				this.getTeacher();
			},
			methods:{
				
				stringToBase64(str) {
					let encodedStr = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
						(match, p1) => String.fromCharCode('0x' + p1)
					);
					return btoa(encodedStr);
				},
				//*************************************************************
				send_sms(){
                var text = '';
                if(this.val.data.status.val==1){
                    text = " مدرس گرامی؛ \n حساب کاربری شما فعال شد. از حضور شما به عنوان استاد، در ایزی تیک خرسندیم. \nبه منظور انتخاب کلاس توسط کاربران، لطفاً ساعات مورد نظر خود برای تدریس را مشخص نمایید. مشاهده راهنمای نحوه انتخاب روز و زمان برگزاری کلاس \n osbn.ir/clscr \n \n ticket.siadat.net";
                }if(this.val.data.status.val==11){
                    text = "مدرس گرامی؛ \n وضعیت پروفایل شما به دلیل نقص مدارک به 'غیر فعال' تغییر پیدا کرد. لطفاً نسبت به تکمیل مدارک، در حساب کاربری خود اقدام نمایید.\n \n ticket.siadat.net";
                }if(this.val.data.status.val==2){
                    text = "مدرس گرامی؛ \n  وضعیت پروفایل شما به 'غیر فعال' تغییر پیدا کرد. به منظور کسب اطلاعات بیشتر، با پشتیبانی ایزی تیک تماس بگیرید. شماره تماس پشتیبانی 02188618512 \n \n ticket.siadat.net";
                }if(this.val.data.status.val==12){
                    text = "مدرس گرامی؛ \n متأسفانه وضعیت پروفایل شما به 'رد شده' تغییر پیدا کرد. به منظور کسب اطلاعات بیشتر با پشتیبانی ایزی تیک تماس بگیرید. \nپشتیبانی 02188618512 \n \n ticket.siadat.net";
                }
				text = this.stringToBase64(this.stringToBase64(text));
			window.$.post(window.sendSms, {token: this.$localStorage.get("user"), phn: this.val.data.phone.val, txt: text }, function(){
				}, "json");
            },
			//************************************************************ */
				file_to_tag(file = ""){
					var html = "";
					if (file.includes(".mp4")) {
							html = "<video style='width:100%;' autoplay controls ><source src='"+this.imgurl + file+"' ></video>";
					} else if (file.includes(".jpg") || file.includes(".jpeg") || file.includes(".png")) {
						html += "<img src='" + this.imgurl + file+"' style='width:100%;' >"
					}else{
						html = "<div class='text-center'><a target='_blank' href='" + this.imgurl + file+"'> پیوست ارسالی </a></div>"
					}
					return html;
				},
				//*********************************************************************
				check_authentication(ttl="", fld=""){
					ttl = "آیا " + ttl + " را تایید می‌کنید؟";
					var html = "";
					if (fld=="img") {
						html = window.$('#val_'+fld).clone();
						html[0].className = html[0].className+" m-auto";
						html = window.$('<div>').append(html).html();
					} else if (fld=="files") {
						var f1 = this.val.data.files.val;
						f1 =  f1 ? JSON.parse(f1) : f1;
						if(typeof f1 == 'object' && !Array.isArray(f1) && f1 != null) {
							for (const key in f1) {
								if(key == "f1") {
									f1[key].forEach((val) => html += this.file_to_tag(val.fileUpload));
								}
							}
						}
					}	 else if (fld=="pic_certificate") {
						var f1 = this.val.data.files.val;
						f1 =  f1 ? JSON.parse(f1) : f1;
						if(typeof f1 == 'object' && !Array.isArray(f1) && f1 != null) {
							for (const key in f1) {
								if(key == "f2") {
									f1[key].forEach((val) => html += this.file_to_tag(val.fileUpload));
								}
							}
						}
						// var f1 = this.val.data.files.val.f2;
						// for (var i = 0; i < f1.length; i++) {
						// 	html += this.file_to_tag(f1[i].fileUpload);
						// }
					}	 else if (fld=="pic_location" || fld=="video" || fld=="pic_documents" || fld=="image_teacher") {
						var f1 = this.val.data[fld].val;
						f1 =  f1 ? JSON.parse(f1) : f1;
						for (var i = 0; i < f1.length; i++) {
							html += this.file_to_tag(f1[i].fileUpload);
						}

					}	else if (fld=="location") {
						var location = JSON.parse(this.val.data.location.val);
						html = "<div class='text-center'><a target='_blank' href='https://maps.google.com/?q="+location[1]+","+location[0]+"'>موقعیت جغرافیایی کاربر</a></div>"
					}
					else if (fld=="about_me") {
						html = "<div class='text-justify'>" + this.val.data[fld].val + "</div>";
					}
					else {
						html = "<div class='text-center'>" + window.$('#val_'+fld).val() + "</div>";
					}
					this.$swal.fire({
						position: 'center',
						type: '',
						html: html ,
						title: ttl,
						showCloseButton: true,
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: "تایید",
						cancelButtonText: "رد",
						confirmButtonColor: "#1b60c6",
						cancelButtonColor: "#E90000",
					}).then((result) => {
						if(fld=="pid_pic" || fld=="pic_certificate"){
							fld = "files";
						}
						if(result.value){
							this.val.data[fld].act = 1;
						}else{
							this.val.data[fld].act = 0;
						}
						this.sav_fld(fld, this.val.data[fld].act);
					});
				},
				// **************************************************************
				showRule(THIS = this){
					var index_text = this.indexFinder(this.$localStorage.get('settings'), "16");
					THIS.$swal.fire({
						position: 'center',
						type: '',
						html: "<p class='text-justify'>" + this.$localStorage.get('settings')[index_text].dsc + "</p>" ,
						width: '80%',
						title: this.$localStorage.get('settings')[index_text].title,
						showCloseButton: true,
						showConfirmButton: true,
						confirmButtonText: "بستن",
					});
				},
				// *********************************************************************
				getTeacher(THIS = this){
					window.$.post(
						this.baseurl+'teachers/authentication',
						{token: this.$localStorage.get("user"), id: this.$route.params.id },
					function(D){
						THIS.val = D;
						THIS.success_sm(THIS, "آماده شد");
					}, "json");
				},
				// *********************************************************************
				sav_fld(fld, act, THIS = this){
					window.$.post(
						this.baseurl+'teachers/authentication',
						{
							token: this.$localStorage.get("user"),
							id: this.$route.params.id,
							fld: fld,
							act: act,
						},
					function(D){

					}, "json");
				},
				// *********************************************************************
				sav_final( THIS = this){
					this.send_sms();
					window.$.post(
						this.baseurl + 'teachers/authentication',
						{
							token: this.$localStorage.get("user"),
							id: this.$route.params.id,
							val: this.val.data
						},
					function(D){
						THIS.success(THIS);
						THIS.$router.push('/teachers/list/2');
						// THIS.$router.replace('/teachers/new');
					}, "json");
				},
			}
		}
</script>
<style>
</style>